import request from 'lib/request';

interface Response {
  code: number;
  msg: string;
  data?: null;
}

export async function setEmail(email: string, anti_phishing_code: string) {
  const res = await request<Response>('/user_profile/set_email', {
    method:'POST',
    data: {
      email,
      anti_phishing_code,
    },
  });
  return res;
}
